import React from 'react';
import { meetings } from '../data/content';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
const numberColors = ['text-coral-ink', 'text-brand', 'text-violet-ink'];

/** The 10 complete plays with their occasion and ages */
export function MeetingsList() {
  return <section id="programs" aria-labelledby="programs-title" className="scroll-mt-4 bg-mist py-12 md:py-20" data-id="element-187" data-mp="7k54rdpa7xet">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-188" data-mp="3fzou41mu0vol">
        <SectionHeading id="programs-title" eyebrow={meetings.eyebrow} title={meetings.title} sub={meetings.sub} data-id="element-189" data-mp="3bxldkylb30wg" />

        <ol className="mx-auto mt-8 grid max-w-[980px] gap-3 md:mt-12 md:grid-cols-2 md:gap-4" data-id="element-190" data-mp="3pxd05npw1pm2">
          {meetings.items.map((m, i) => <li key={m.n} className="flex gap-3 rounded-xl border border-mist-line bg-white p-5" data-id="element-191" data-mp="3kwoxu5w7lmcj" data-mpi={i}>
              <span className={`w-12 shrink-0 font-display text-[1.9rem] font-black leading-none ${numberColors[i % numberColors.length]}`} data-id="element-192" data-mp="155140jchs9xy">{m.n}</span>
              <div className="min-w-0" data-id="element-193" data-mp="17toovhxy7a3p">
                <p className="text-[11px] font-bold tracking-[0.1em] text-ink/55" data-id="element-194" data-mp="17sn9505zlzfn">{m.tag}</p>
                <h3 className="mt-0.5 font-display text-[16px] font-extrabold uppercase leading-snug tracking-tight text-ink" data-id="element-195" data-mp="1cqosznb8m2s6">{m.title}</h3>
                <p className="mt-1 text-[15px] leading-relaxed text-ink/75" data-id="element-196" data-mp="1mqfo9r7mgltb">{m.goal}</p>
              </div>
            </li>)}
        </ol>

        <div className="mx-auto mt-10 flex max-w-[460px] justify-center" data-id="element-197" data-mp="p4076qj3xq6a">
          <CtaButton label={meetings.cta} microcopy={meetings.ctaMicrocopy} align="center" data-id="element-198" data-mp="u18s2yvn48b8" />
        </div>
      </div>
    </section>;
}